/*eslint-disable*/
import React from 'react';
import AppContext from "../../../context/AppContext";

import { Popup } from 'devextreme-react/popup';
import { Button, Card, CardHeader, CardBody, Row, Col, CardTitle } from 'reactstrap';
import DataGrid, { Column } from 'devextreme-react/data-grid';
import { locale } from "devextreme/localization";

import { config } from '../../../utils/config';
import { callApi, callKrakenApi } from '../../../utils/utils';

import Template8Grid from './Template8Grid';
import Template8Alta from './Template8Alta';

export default class Template8 extends React.Component{
    constructor(props) {
        super(props);    

        const filtros = {
            claUbicaion: null,
            claFamilia: null,
            claSubFamilia: null,
            claProducto: null,
            idConfiguracion: null,
            claTemplate: 8
        };

        this.state = {
            showSpin: false,
            filtros,  
            pageIndex: 0,
            popupVisible: false,
        }

        this.getConfiguraciones = this.getConfiguraciones.bind(this);
        this.getUbicaciones= this.getUbicaciones.bind(this);
        this.onGridPage = this.onGridPage.bind(this);  
        this.validateRemove = this.validateRemove.bind(this);
        this.hidePopUp = this.hidePopUp.bind(this);
        this.handler = this.handler.bind(this);
        this.onClickAgregar = this.onClickAgregar.bind(this);
       
    }

    validateRemove(e){
        const urlApiService = `${process.env.REACT_APP_URL_API}Configuraciones/DeleteTemplate8`;

        var params = {
            idCfgConfiguracionGeneral: e.data.IdCfgConfiguracionGeneral,
            idConfiguracion: e.data.IdConfiguracion,
            claUbicacion: parseInt(e.data.ClaUbicacion),
        }

        callApi(urlApiService, 'POST', params, (result) => {
            this.getConfiguraciones();
        });
    }

    getConfiguraciones(){
        const urlApiService = `${process.env.REACT_APP_URL_API}Configuraciones/ConfiguracionGeneral`;

        callApi(urlApiService, 'POST', this.state.filtros, (result) => {

            this.setState({
                configData: result,
                showSpin: false
            });
        });
    }

    getUbicaciones(){
        var params = {
            Valor: '',
            Tipo: 1,
            IncluirTodosSN: 0,
        };
      
        callKrakenApi(8, 258, params, 1, (res) => {
            this.setState({
                UbicacionData: res.Result0
            })
        });
    }

///////// POPUP
    handler(val) {
        this.setState({
        popupVisible: val,
        });
    }

    hidePopUp() {
        this.setState({
        popupVisible: false,
        });
    }
////////

    onGridPage(pageIndex) {
        this.setState({ pageIndex });
    }
    
    onClickAgregar(e) {
        this.setState({
          popupVisible: true,
        });
    
        e.stopPropagation();
    }

    componentDidMount(){
        let newfiltros = this.state.filtros;
        newfiltros.idConfiguracion = this.props.configuracionValue
        this.setState({
            filtros: newfiltros
        })
        this.getConfiguraciones();
        this.getUbicaciones();
    }

    componentDidUpdate(){        
        if(this.state.filtros.idConfiguracion !== this.props.configuracionValue)
        {
            let newfiltros = this.state.filtros;
            newfiltros.idConfiguracion = this.props.configuracionValue
            this.state.filtros = newfiltros;
            this.getConfiguraciones();
        }
    }

    render(){
        const content = (
            <>
                <Row>
                    <Col md={{ size: 1, offset: 11 }} style={{ textAlign: 'center' }}>
                        <Button
                            id="btnNuevo"
                            onClick={this.onClickAgregar}
                            size="md"
                            className="btn btn-primary btn-round btn-icon btn-custom mb-1"
                        >
                            <i className="fa fa-plus" />
                        </Button>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Template8Grid 
                            configData={this.state.configData}
                            pageIndex={this.state.pageIndex}
                            onPage={this.onGridPage}
                            validateRemove={this.validateRemove}
                        />
                    </Col>
                </Row>
                
                    <Popup
                    key="popupConfig"
                    id="popupConfig"
                    visible={this.state.popupVisible}
                    onHiding={this.hidePopUp}
                    dragEnabled={false}
                    closeOnOutsideClick={true}
                    showTitle={true}
                    title="Alta de Configuración"
                    width={470}
                    height={400}
                    >
                    <Template8Alta 
                        idConfiguracion={this.props.configuracionValue}
                        handler={this.handler}
                        UbicacionData={this.state.UbicacionData}
                        getConfiguraciones={this.getConfiguraciones}
                    />
                </Popup>
            </>
        );

        return(
            <div className="content mb-5">
                {content}
            </div>
        )
    }
}